<template>
  <div>
    <ModalCover @closeModal="$emit('closeTriggered')" modal_style="rounded-10">
      <div slot="modal-cover-body">
        <!-- MODAL TITLE -->
        <div class="py-4 px-3">
          <span class="modal-title font-weight-bold">SWITCH CLASS</span>
        </div>

        <div
          class="select-class-row pointer"
          :class="getActiveClass == class_data.id ? 'active-class' : null"
          v-for="(class_data, index) in current_subject.assigned_classes"
          :key="index"
          @click="switchClass(class_data.id)"
        >
          <div class="text">{{ class_data.class_name }}</div>
          <div
            class="avatar avatar-sm brand_inverse_bg"
            v-if="getActiveClass == class_data.id"
          >
            <div class="icon-accept white-text font-18 flex-center"></div>
          </div>
        </div>

        <div
          class="assign-more w-100 text-center font-weight-bold brand_navy brand_accent_light_bg font-13-5 py-3 pointer"
          @click="$emit('showAssignClass')"
        >
          Assign to More Classes
        </div>
      </div>
    </ModalCover>
  </div>
</template>

<script>
import ModalCover from "@/components/globalComps/ModalCover";

export default {
  name: "SelectClassModal",

  components: {
    ModalCover,
  },

  props: {
    current_subject: Object,
  },

  computed: {
    getActiveClass() {
      if (this.$route.query.class_id) return this.$route.query.class_id;
      else return this.current_subject.assigned_classes[0].id;
    },
  },

  data() {
    return {
      current_class: null,
    };
  },

  methods: {
    switchClass(id) {
      this.$router.push({
        name: "SchoolSettingsSubjectDetails",
        query: { subject: this.current_subject.slug, class_id: id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-title {
  @include breakpoint_max(sm) {
    font-size: 14px !important;
  }
}

.select-class-row {
  @include flex_row_between_nowrap;
  padding: 13px 15px;

  .text {
    color: $color_text;
    font-size: 14px;
    line-height: 19px;
  }

  .avatar {
    @include equal_min_edge(26);
  }

  &:hover {
    background: $color_white !important;
  }
}

.active-class {
  background: $color_white !important;

  .text {
    font-weight: 600;
  }
}
</style>
